export const EXTRACT_SUBDOCUMENT_GROUP = "extractSubdocumentGroup";
export const EXTRACT_SUBDOCUMENT_SUBGROUP = "extractSubdocumentSubgroup";
export const EXTRACT_SUBDOCUMENT_ID = "extractSubdocumentId";
export const EXTRACT_SUBDOCUMENT_TRIGGER = "extractSubdocumentTrigger";
